module.exports = __webpack_public_path__ + "static/Foodservice-Photo2-6a920528a0a5ae49fa9e680b3d7fab03.png";